import axios from 'axios';

import Cookies from "js-cookie";

// Config axios defaults.
const AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_SERVICE,
    timeout: 100000,
});

AxiosInstance.interceptors.request.use((conf) => {

    const newConf = { ...conf };
    
    newConf.data.append("hv_token",(typeof Cookies.get('hv_token')==="undefined") ? "" : Cookies.get('hv_token'))

    newConf.headers['content-type'] = "application/x-www-form-urlencoded";

    newConf.params = conf.params || {};


    return newConf;
});

AxiosInstance.interceptors.response.use(
    (config) => config,
    (error) => {
        if (error.response.status === 403) {
            if(typeof Cookies.get('hv_token')!=="undefined"){
                Cookies.remove('hv_token');
            }
            window.location.reload();
        }
        return Promise.reject(error);
    },
);

export default AxiosInstance;
